import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconSize } from '@freelancer/ui/icon';

@Component({
  template: `
    <app-award-modal-body class="AwardModalBody"
      [bidId]="bidId"
    ></app-award-modal-body>
    <app-award-modal-sidebar class="AwardModalSidebar">
    </app-award-modal-sidebar>
  `,
  styleUrls: ['./award-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AwardModalComponent {
  IconSize = IconSize;
  @Input() bidId: number;
}
